import 'jquery-smooth-scroll';


// WEBPACK FOOTER //
// ./scripts/autoload/_jquery-smooth-scroll.js